import * as React from 'react';
import { OpeningHourProps } from './OpeningHoursTypes';

export const OpeningHours = (props: OpeningHourProps) => {
  const { closed, readableTime, additionalInformation } = props;

  const handleScroll = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault()

    const targetElement = document.querySelector('#openingstijden')
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth'
      })
    }
  }

  return (
    <div className="jumbotron__opening-times">
      <div>Vandaag {closed ? 'gesloten' : `open tussen ${readableTime}`}</div>
      <div>{additionalInformation}</div>
      <a className="link" href="#openingstijden" onClick={handleScroll}>
        Bekijk alle openingstijden
      </a>
    </div>
  )
}